<template>
  <div class="report-content">
    <div id="pdfDom">
      <!-- <img src="../assets/imgs/report-bg.png" alt=""> -->
      <div class="report-header">
        <div class="report-title">
          {{ ReportDataDetails.name }}
          <div class="report-data">报告数据截取日期为{{ nowLastDay }}</div>
        </div>
        <div class="downreport new-location" @click="btnClick">
          <i class="iconfont">&#xe6d0;</i> 下载报告
        </div>
      </div>

      <!-- 市场统计 -->
      <div class="keyFirmCount" v-if="usertype == '企业'">
        <div class="market-one">
          <div class="market-img">
            <i class="iconfont big-icon">&#xe6bf;</i>
          </div>
          <div class="market-text">
            <p>市场主体概况</p>
            <ul>
              <li>
                市场主体数：<span>{{ firmtotalS }}</span> 家
              </li>
              <li>
                新增市场主体数：<span>{{ firmtotalS }}</span> 家
              </li>
            </ul>
          </div>
        </div>
        <div class="market-one" style="width: 40%">
          <div class="market-img">
            <i class="iconfont big-icon">&#xe6bd;</i>
          </div>
          <div class="market-text" style="width: 100%">
            <p>国内专利概况</p>
            <ul class="country-overview">
              <li>
                国内专利申请(已公开)量：<span>{{ count.ptTotal }}</span> 家
              </li>
              <li>
                国内授权专利量：<span>{{ count.ptAuth }}</span> 家
              </li>
              <li>
                PCT专利申请(已公开)量：<span>{{ count.ptPct }}</span> 家
              </li>
            </ul>
          </div>
        </div>
        <div class="market-one" style="border: none; width: 45%">
          <div class="market-img">
            <i class="iconfont big-icon">&#xe6be;</i>
          </div>
          <div class="market-text">
            <p>商标概况</p>
            <ul class="country-overview">
              <li>
                国内商标申请量：<span>{{ count.tmTotal }}</span> 件
              </li>
              <li>
                国内商标注册量：<span>{{ count.tmReg }}</span> 件
              </li>
              <li>
                马德里商标注册量：<span>{{ count.tmMadridReg }}</span> 件
              </li>
              <li>
                驰名商标量：<span>{{ count.tmFamous }}</span> 件
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 概况统计结束 -->

      <!-- 专利统计 -->
      <!-- 2.统计 -->
      <div class="stats" v-if="usertype == '专利'">
        <!-- <div>
          申请（已公开）专利量：<span>{{ dataSummary.apTotal }}</span> 件
        </div> -->

        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6c8;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">申请（已公开）专利量</div>
              <span>{{ topList.apTotal || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>

        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6cf;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">授权专利量</div>
              <span>{{ topList.auTotal || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>

        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6d2;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">有效发明量(累计)</div>
              <span>{{ topList.inventionTotal || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6d3;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">PCT专利量</div>
              <span>{{ topList.pctTotal || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6d3;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">万人发明专利拥有量(累计)</div>
              <span>{{ topList.avgNum || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6d3; </i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">万人价值较高发明专利拥有量(累计)</div>
              <span>{{ topList.highAvgNum || 0 }} </span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>

        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6d3; </i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">专利质押登记量</div>
              <span>{{ topList.zyTotal || 0 }} </span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>

        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6d3; </i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">专利核准转让量</div>
              <span>{{ topList.zrTotal || 0 }} </span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>

        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6d3; </i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">专利许可备案量</div>
              <span>{{ topList.xkTotal || 0 }} </span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 统计结束 -->
      <!-- 商标统计 -->
      <!-- 2.统计 -->
      <div class="stats" v-if="usertype == '商标'">
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6c3;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">商标申请量</div>
              <span>{{ dataSummary.tmApNum || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6bf;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">商标注册量</div>
              <span>{{ dataSummary.tmRegNum || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6c3;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">商标有效注册量</div>
              <span>{{ dataSummary.tmValidRegNum || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6c3;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">马德里商标注册量</div>
              <span>{{ dataSummary.madridRegNum || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6bf;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">万人有效商标持有量</div>
              <span>{{ dataSummary.avgValidNum || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6be;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">商标核准转让量</div>
              <span>{{ dataSummary.tmTrfNum || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6c4;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">商标许可备案量</div>
              <span>{{ dataSummary.tmLicNum || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
        <div class="trademark-one">
          <div class="trademark-img"><i class="iconfont">&#xe6b7;</i></div>
          <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">商标质押登记量</div>
              <span>{{ dataSummary.tmPldNum || 0 }}</span>
              <span class="trandemark-num1">件</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 统计结束 -->
      <!-- 专利数据视图开始 -->
      <div class="report-alasyis" v-if="usertype == '专利'">
        <div
          style="
            height: 11px;
            width: 100%;
            background: #f2f2f2;
            margin-top: 20px;
          "
        ></div>
        <!-- 3.国内专利分析 -->
        <div style="background-color: #fff">
          <div class="inside">
            <div class="inside-title">
              <div></div>
              国内专利分析
            </div>
          </div>
          <!-- <div class="analyTitle">国内专利分析</div> -->
          <!-- <div class="zl1" style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 3-1.国内专利趋势 -->
          <div id="gnzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">国内专利趋势</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="trendApList"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="专利申请量"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num2"
                    label="专利授权量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- <div v-show="!havedata1" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div> -->
          </div>
          <!-- 3-2.专利类型构成 -->
          <div id="zllxgc" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">专利类型构成</p>

            <!-- 数据视图 -->
            <div>
              <el-table
                :data="apTyCountzl"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="专利类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利申请量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-table
                :data="apTyAuthCountzl"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="专利类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利授权量"
                >
                </el-table-column>
              </el-table>
            </div>
            <!-- <div  class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div> -->
          </div>
          <!-- </div> -->
          <!-- 3-3.申请人构成及趋势 -->
          <div id="sqrgc" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">申请人构成及趋势</p>

            <!--面积图  -->

            <!-- <div  class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
            <!-- 数据视图 -->
            <div>
              <div class="apply-num">申请量</div>
              <table class="myTable" style="margin: 2% auto 0">
                <tr>
                  <th>申请人类型</th>
                  <th v-for="(item, index) of timeRange" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>工矿企业</td>
                  <td v-for="(gk, gkindex) in reportgkcompany" :key="gkindex">
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>科研院所</td>
                  <td
                    v-for="(ky, kyindex) of this.reportsciencedw"
                    :key="kyindex"
                  >
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>大专院校</td>
                  <td
                    v-for="(dz, dzindex) of this.reportdzschool"
                    :key="dzindex"
                  >
                    {{ dz }}
                  </td>
                </tr>
                <tr>
                  <td>机关团体</td>
                  <td
                    v-for="(jg, jgindex) of this.reportjggroup"
                    :key="jgindex"
                  >
                    {{ jg }}
                  </td>
                </tr>
                <tr>
                  <td>个人</td>
                  <td
                    v-for="(man, manindex) of this.reportsingle"
                    :key="manindex"
                  >
                    {{ man }}
                  </td>
                </tr>
              </table>
            </div>

            <div>
              <div class="apply-num">授权量</div>
              <table class="myTable" style="margin: 2% auto 0">
                <tr>
                  <th>申请人类型</th>
                  <th v-for="(item, index) of timeRange" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>工矿企业</td>
                  <td
                    v-for="(gk, gkindex) of this.reportgkcompanyAuth"
                    :key="gkindex"
                  >
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>科研院所</td>
                  <td
                    v-for="(ky, kyindex) of this.reportsciencedwAuth"
                    :key="kyindex"
                  >
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>大专院校</td>
                  <td
                    v-for="(dz, dzindex) of this.reportdzschoolAuth"
                    :key="dzindex"
                  >
                    {{ dz }}
                  </td>
                </tr>
                <tr>
                  <td>机关团体</td>
                  <td
                    v-for="(jg, jgindex) of this.reportjggroupAuth"
                    :key="jgindex"
                  >
                    {{ jg }}
                  </td>
                </tr>
                <tr>
                  <td>个人</td>
                  <td
                    v-for="(man, manindex) of this.reportsingleAuth"
                    :key="manindex"
                  >
                    {{ man }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!-- 3-4.IPC技术分类Top10 -->
          <div id="ipcjstop10" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">IPC技术分类Top10</p>
            <!-- <div class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
            <!-- 数据视图 -->
            <div>
              <el-table
                :data="ipcCount"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="IPC分类">
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利申请量"
                >
                </el-table-column>
              </el-table>
            </div>

            <div>
              <el-table
                :data="ipcAuthCount"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="IPC分类">
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利授权量"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 3-5.有效专利权利人分布 -->
          <div id="yxfmwcfb" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">有效专利权利人分布</p>

            <!-- 数据视图 -->
            <div>
              <!--  <div class="apply-num">外观设计 实用新型</div> -->
              <div class="apply-num">发明专利</div>
              <!-- 数据视图 -->

              <el-table
                :data="apValidInvzl"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="权利人类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="权利人数量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div>
              <div class="apply-num">实用新型</div>
              <!-- 数据视图 -->
              <el-table
                :data="utilityValidInvzl"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="权利人类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="权利人数量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div>
              <div class="apply-num">外观设计</div>
              <!-- 数据视图 -->

              <el-table
                :data="designValidInvzl"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="权利人类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="权利人数量"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 4-1.专利质押登记量趋势 -->
          <div id="pctzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">专利质押登记量趋势</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="zyTrend"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="time" label="时间">
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="专利质押登记量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- 4-1.专利质押登记量趋势 -->
          <div id="pctzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">专利核准转让量趋势</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="zrTrend"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="time" label="时间">
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="专利核准转让量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- 4-1.专利核准转让量趋势 -->
          <div id="pctzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">专利许可备案量趋势</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="xkTrend"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="time" label="时间">
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="专利许可备案量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>

          <!-- 3-6.国内专利分析榜单 -->
          <div id="gnzlfxbd" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">国内专利分析榜单</p>
            <!-- <div class="sqSwitch">
            <button @click="applybtn(9)" :class="{ numbtn: numType5 == 9 }">
              申请量
            </button>
            <button @click="agreebtn(10)" :class="{ numbtn: numType5 == 10 }">
              授权量
            </button>
            <button @click="yxfmbtn(11)" :class="{ numbtn: numType5 == 11 }">
              有效发明量(累计)
            </button>
            <button @click="wxzlbtn(12)" :class="{ numbtn: numType5 == 12 }">
              无效专利量
            </button>
          </div> -->

            <!-- 数据视图 -->
            <div>
              <div class="titleBox">
                <el-button
                  @click="zlseeMore50(101)"
                  :disabled="appTop10.length === appTop50.length"
                  >更多</el-button
                >
              </div>
              <el-table :data="appTop10" border stripe class="el-tableclass">
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利申请量"
                >
                </el-table-column>
              </el-table>
              <!-- <div v-if="isTableData">
              <el-table :data="tableData50" border class="el-tableclass">
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="序号"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column :resizable="false" prop="num">
                </el-table-column>
              </el-table>
            </div> -->
            </div>

            <div>
              <div class="titleBox">
                <el-button
                  @click="zlseeMore50(102)"
                  :disabled="authTop10.length === authTop50.length"
                  >更多</el-button
                >
              </div>
              <el-table :data="authTop10" border stripe class="el-tableclass">
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利授权量"
                >
                </el-table-column>
              </el-table>
            </div>

            <div>
              <div class="titleBox">
                <el-button
                  @click="zlseeMore50(103)"
                  :disabled="validTop10.length === validTop50.length"
                  >更多</el-button
                >
              </div>
              <el-table :data="validTop10" border stripe class="el-tableclass">
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="有效发明量(累计)"
                >
                </el-table-column>
              </el-table>
            </div>

            <div>
              <div class="titleBox">
                <el-button
                  @click="zlseeMore50(104)"
                  :disabled="notValidTop50.length === notValidTop50.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="notValidTop10"
                border
                stripe
                class="el-tableclass"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="无效专利量"
                >
                </el-table-column>
              </el-table>
            </div>
            <!-- <div
            
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
          </div>
        </div>
        <!-- <div
        style="height: 20px; width: 100%; background: #f2f2f2; margin-top: 20px"
      ></div> -->
        <!-- 4.PCT公开专利分析 -->
        <div style="background: #fff">
          <div class="inside">
            <div class="inside-title">
              <div></div>
              PCT公开专利分析
            </div>
          </div>
          <!-- <div class="analyTitle">PCT公开专利分析</div> -->
          <!-- <div -->

          <!-- 4-1.PCT专利趋势 -->
          <div id="pctzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">PCT专利趋势</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="pctTrendCount"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="公开量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- 4-2.IPC分类Top10 -->
          <div id="ipctop10" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">IPC分类Top10</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="pctIpcTop10"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="IPC分类"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="申请量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- <div  class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div> -->
          </div>
          <!-- </div> -->
          <!-- 4-3.PCT公开量Top10 -->
          <div id="pctzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">PCT公开量Top10</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <div class="titleBox">
                  <el-button
                    @click="zlseeMore50(105)"
                    :disabled="pctTop10Count.length === pctTop50Count.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="pctTop10Count"
                  border
                  stripe
                  style="width: 90%; margin: 0 auto"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="企业名称"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="公开量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- <div  class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
          </div>
        </div>
        <!-- <div style="height: 20px; width: 100%; background: #f2f2f2"></div> -->
        <!--5.专利状态分析  -->
        <div style="background: #fff">
          <div class="inside">
            <div class="inside-title">
              <div></div>
              专利状态分析
            </div>
          </div>
          <!-- <div class="analyTitle">专利状态分析</div> -->
          <div id="zlztfx" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">专利状态分析</p>
            <div>
              <!--饼状图  -->

              <!--数据视图  -->
              <div>
                <el-table
                  :data="ptLawCount"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="法律状态"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="专利量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- <div  class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
          </div>
        </div>
        <!-- <div style="height: 20px; width: 100%; background: #f2f2f2"></div> -->
        <!--6.区域专利比较  -->
        <div style="background: #fff">
          <div class="inside">
            <div class="inside-title">
              <div></div>
              区域专利比较
            </div>
          </div>
          <div id="qyzlbj" class="patent" style="margin-bottom: 20px">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">区域专利比较</p>

            <!--面积图  -->

            <!--数据视图  -->
            <div class="table-trdata">
              <div class="apply-num">申请量</div>
              <table class="myTable">
                <tr>
                  <th>专利类型</th>
                  <th v-for="(item, index) of ApplyXzl" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>发明</td>
                  <td v-for="(gk, gkindex) of ApplyFM" :key="gkindex">
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>实用新型</td>
                  <td v-for="(ky, kyindex) of ApplySY" :key="kyindex">
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>外观设计</td>
                  <td v-for="(dz, dzindex) of ApplyWG" :key="dzindex">
                    {{ dz }}
                  </td>
                </tr>
              </table>
            </div>
            <!-- <div
           
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
            <div class="table-trdata">
              <div class="apply-num">授权量</div>
              <table class="myTable">
                <tr>
                  <th>专利类型</th>
                  <th v-for="(item, index) of AuthXzl" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>发明</td>
                  <td v-for="(gk, gkindex) of AuthFM" :key="gkindex">
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>实用新型</td>
                  <td v-for="(ky, kyindex) of AuthSY" :key="kyindex">
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>外观设计</td>
                  <td v-for="(dz, dzindex) of AuthWG" :key="dzindex">
                    {{ dz }}
                  </td>
                </tr>
              </table>
            </div>

            <div class="table-trdata">
              <div class="apply-num">PCT申请量</div>
              <table class="myTable">
                <tr>
                  <th>专利类型</th>
                  <th v-for="(item, index) of pctXzl" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>发明</td>
                  <td v-for="(gk, gkindex) of pctFM" :key="gkindex">
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>实用新型</td>
                  <td v-for="(ky, kyindex) of pctSY" :key="kyindex">
                    {{ ky }}
                  </td>
                </tr>
              </table>
            </div>

            <div class="table-trdata">
              <div class="apply-num">有效专利量(累计)</div>
              <table class="myTable">
                <tr>
                  <th>专利类型</th>
                  <th v-for="(item, index) of wxXzl" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>发明</td>
                  <td v-for="(gk, gkindex) of wxFM" :key="gkindex">
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>实用新型</td>
                  <td v-for="(ky, kyindex) of wxSY" :key="kyindex">
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>外观设计</td>
                  <td v-for="(dz, dzindex) of wxWG" :key="dzindex">
                    {{ dz }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div style="height: 30px; width: 100%; background: #f2f2f2"></div>
        <!-- 专利top50弹框-->
        <div v-if="zlseeMore" class="popBoxMask"></div>
        <div v-if="zlseeMore" class="popBox">
          <div class="boxHeader">
            {{ label50 }}排名
            <i class="el-icon-close" @click="closeMore"> </i>
          </div>
          <div class="boxContent">
            <div class="titleBox" style="width: 100%; margin-top: 0">
              <span
                style="
                  font-size: 18px;
                  color: #000;
                  text-align: left;
                  margin-left: 28px;
                  line-height: 50px;
                  font-weight: bold;
                "
                >{{ label50 }}Top50</span
              >
              <el-button @click="daochu(label50)">导出Excel</el-button>
            </div>
            <el-table :data="tableData50" border style="width: 100%">
              <el-table-column
                :resizable="false"
                type="index"
                label="序号"
                width="60"
              >
              </el-table-column>
              <el-table-column :resizable="false" prop="name" label="企业名称">
              </el-table-column>
              <el-table-column :resizable="false" prop="num" :label="label50">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 专利数据视图结束 -->
      <!-- 商标数据视图开始 -->
      <div class="report-alasyis" v-if="usertype == '商标'">
        <div
          style="
            height: 11px;
            width: 100%;
            background: #f2f2f2;
            margin-top: 20px;
          "
        ></div>
        <!-- 3.国内专利分析 -->
        <div style="background-color: #fff">
          <div class="inside">
            <div class="inside-title">
              <div></div>
              国内商标分析
            </div>
          </div>
          <!-- <div class="analyTitle">国内专利分析</div> -->
          <!-- <div class="zl1" style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 3-1.国内专利趋势 -->
          <div id="gnzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">国内商标趋势</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="tmTrendMap"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="申请量">
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num2"
                    label="注册量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- <div v-show="!havedata1" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div> -->
          </div>
          <!-- 3-2.国际分类Top10 -->
          <div id="zllxgc" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">国际分类Top10</p>
            <!-- <div class="sqSwitch">
              <button @click="applybtn(1)" :class="{ numbtn: numType1 == 1 }">
                申请量
              </button>
              <button @click="agreebtn(2)" :class="{ numbtn: numType1 == 2 }">
                授权量
              </button>
            </div> -->
            <!-- 数据视图 -->
            <div>
              <el-table
                :data="icTop10Map"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column :resizable="false" prop="IC" label="国际分类">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="申请量">
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-table
                :data="icRegTop10Map"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column :resizable="false" prop="IC" label="国际分类">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="注册量">
                </el-table-column>
              </el-table>
            </div>
            <!-- <div  class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div> -->
          </div>
          <!-- </div> -->
          <!-- 3-3.申请人构成及趋势 -->
          <div id="sqrgc" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">申请人构成及趋势</p>

            <!--面积图  -->

            <!-- <div  class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
            <!-- 数据视图 -->
            <div>
              <div class="apply-num">申请量</div>

              <table class="myTable">
                <tr>
                  <th>申请人类型</th>
                  <th v-for="(item, index) of tmtimeRange" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>工矿企业</td>
                  <td v-for="(gk, gkindex) of gkcompanysb" :key="gkindex">
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>科研院所</td>
                  <td v-for="(ky, kyindex) of sciencedwsb" :key="kyindex">
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>大专院校</td>
                  <td v-for="(dz, dzindex) of dzschoolsb" :key="dzindex">
                    {{ dz }}
                  </td>
                </tr>
                <tr>
                  <td>机关团体</td>
                  <td v-for="(jg, jgindex) of jggroupsb" :key="jgindex">
                    {{ jg }}
                  </td>
                </tr>
                <tr>
                  <td>个人</td>
                  <td v-for="(man, manindex) of singlesb" :key="manindex">
                    {{ man }}
                  </td>
                </tr>
              </table>
            </div>

            <div>
              <div class="apply-num">注册量</div>
              <table class="myTable" style="margin: 2% auto 0">
                <tr>
                  <th>申请人类型</th>
                  <th v-for="(item, index) of tmtimeRange" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>工矿企业</td>
                  <td
                    v-for="(gk, gkindex) of this.gkcompanyAuthsb"
                    :key="gkindex"
                  >
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>科研院所</td>
                  <td
                    v-for="(ky, kyindex) of this.sciencedwAuthsb"
                    :key="kyindex"
                  >
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>大专院校</td>
                  <td
                    v-for="(dz, dzindex) of this.dzschoolAuthsb"
                    :key="dzindex"
                  >
                    {{ dz }}
                  </td>
                </tr>
                <tr>
                  <td>机关团体</td>
                  <td
                    v-for="(jg, jgindex) of this.jggroupAuthsb"
                    :key="jgindex"
                  >
                    {{ jg }}
                  </td>
                </tr>
                <tr>
                  <td>个人</td>
                  <td
                    v-for="(man, manindex) of this.singleAuthsb"
                    :key="manindex"
                  >
                    {{ man }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!-- 3-4.国内商标分析榜单 -->
          <div id="ipcjstop10" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">国内商标分析榜单</p>
            <!-- <div class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
            <!-- 数据视图 -->
            <div>
              <div class="titleBox">
                <el-button
                  @click="trseeMore50(10)"
                  :disabled="topApp10Map.length === topApp50Map.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="topApp10Map"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="申请量">
                </el-table-column>
              </el-table>
            </div>
            <div>
              <div class="titleBox">
                <el-button
                  @click="trseeMore50(11)"
                  :disabled="topReg10Map.length === topReg50Map.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="topReg10Map"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>

                <el-table-column :resizable="false" prop="num" label="注册量">
                </el-table-column>
              </el-table>
            </div>
            <div>
              <div class="titleBox">
                <el-button
                  @click="trseeMore50(12)"
                  :disabled="topValid10Map.length === topValid50Map.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="topValid10Map"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>

                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="有效注册量"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 3-5.马德里商标分析 -->
          <div class="inside">
            <div class="inside-title">
              <div></div>
              马德里商标分析
            </div>
          </div>
          <div id="yxfmwcfb" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">马德里商标趋势</p>

            <!-- 数据视图 -->
            <div>
              <el-table
                :data="madridTrend"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column :resizable="false" prop="name" label="时间">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="公开量">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 3-6.马德里延伸国家TOP20 -->
          <div id="gnzlfxbd" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">马德里延伸国家TOP20</p>

            <!-- 数据视图 -->
            <div>
              <el-table
                :data="madridExtendTop20"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                ></el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="马德里延伸国家"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="马德里注册量"
                >
                </el-table-column>
              </el-table>
              <!-- <el-table :data="madridExtendTop20" border stripe style="width: 90%; margin: 2% auto 0">
                  <el-table-column :resizable="false" type="index" label="排序" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 11 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :resizable="false" prop="name" label="马德里延伸国家">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="马德里注册量">
                  </el-table-column>
                </el-table> -->
            </div>
          </div>
          <!-- 3-7.马德里注册量榜单 -->
          <div id="gnzlfxbd" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">马德里注册量榜单</p>

            <!-- 数据视图 -->
            <div>
              <div class="titleBox">
                <el-button
                  @click="trseeMore50(13)"
                  :disabled="madridTop10.length === madridTop50.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="madridTop10"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                ></el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="马德里注册量"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- <div
        style="height: 20px; width: 100%; background: #f2f2f2; margin-top: 20px"
      ></div> -->
        <!-- 4.商标状态分析 -->
        <div style="background: #fff">
          <div class="inside">
            <div class="inside-title">
              <div></div>
              商标状态分析
            </div>
          </div>
          <!-- <div class="analyTitle">PCT公开专利分析</div> -->
          <!-- <div -->

          <!-- 4-1.商标状态分析 -->
          <div id="pctzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">商标状态分析</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="lawMap"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    prop="ls"
                    label="法律状态"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="商标量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>

          <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
          <!-- 7. 商标运营分析-->
          <div>
            <div class="analyTitle">
              <div class="inside">
                <div class="inside-title">
                  <div></div>
                  商标运营分析
                </div>
              </div>
            </div>
            <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
            <!-- 7-1.商标转让趋势 -->
            <div id="sbturn1" class="patent" style="margin-bottom: 20px">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标转让趋势</p>

              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="tmTransferMap"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="转让量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 7-2.商标转让类别Top10 -->
            <div id="sbturn2" class="patent" style="margin-bottom: 20px">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>

              <p class="biaoTitle">商标转让类别Top10</p>
              <div>
                <!-- 数据视图 -->
                <div>
                  <el-table
                    :data="tmIcTrfTop"
                    border
                    stripe
                    style="width: 90%; margin: 2% auto 0"
                  >
                    <el-table-column
                      :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="name"
                      label="国际分类"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="转让量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <!-- </div> -->
            <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
            <!-- 7-3.商标许可趋势 -->
            <div id="sbagree1" class="patent">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标许可趋势</p>
              <div>
                <!-- 数据视图 -->

                <el-table
                  :data="tmLicenseMap"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="许可量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 7-4.商标许可类别Top10 -->
            <div id="sbagree2" class="patent">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标许可类别Top10</p>

              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="tmIcLicTop"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="国际分类"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="许可量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- </div> -->
            <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
            <!-- 7-5.商标质押趋势 -->
            <div id="sbzy1" class="patent">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标质押趋势</p>

              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="tmPledgeMap"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="质押量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 7-6.商标质押类别Top10 -->
            <div
              id="sbzy2"
              class="patent"
              style="margin-top: 22px; margin-bottom: 22px"
            >
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标质押类别Top10</p>

              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="tmIcPldTop"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="国际分类"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="质押量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- </div> -->
            <!-- 7-7. 商标运营分析榜单-->
            <div id="sbmanitop" class="patent">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle2">商标运营分析榜单</p>

              <!-- 数据视图 -->
              <div>
                <div class="titleBox">
                  <el-button
                    @click="trseeMore50(14)"
                    :disabled="tmTrfTop10.length === tmTrfTop50.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="tmTrfTop10"
                  border
                  stripe
                  class="el-tableclass"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="企业名称"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="商标转让量"
                  >
                  </el-table-column>
                </el-table>
              </div>

              <div>
                <div class="titleBox">
                  <el-button
                    @click="trseeMore50(15)"
                    :disabled="tmLicTop10.length === tmLicTop50.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="tmLicTop10"
                  border
                  stripe
                  class="el-tableclass"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="企业名称"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="商标许可量"
                  >
                  </el-table-column>
                </el-table>
              </div>

              <div>
                <div class="titleBox">
                  <el-button
                    @click="trseeMore50(16)"
                    :disabled="tmPldTop10.length === tmPldTop50.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="tmPldTop10"
                  border
                  stripe
                  class="el-tableclass"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="企业名称"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="商标质押量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
          <!-- 8.区域服务机构分析 -->
          <div>
            <div class="analyTitle">
              <div class="inside">
                <div class="inside-title">
                  <div></div>
                  区域服务机构分析
                </div>
              </div>
            </div>
            <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
            <!-- 8-1.代理机构数量分布 -->
            <div id="sbdlnum" class="patent">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle2">代理机构数量分布</p>

              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="agentDist"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="代理量区间"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="代理机构数量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 8-2.商标代理量Top10 -->
            <div id="sbdlnumtop" class="patent">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle2">商标代理量Top10</p>

              <!-- 数据视图 -->
              <div>
                <div class="titleBox">
                  <el-button
                    @click="trseeMore50(17)"
                    :disabled="agentTmTop10.length === agentTmTop50.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="agentTmTop10"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="AG"
                    label="代理机构"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="商标代理量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- </div> -->
          </div>
          <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
          <!-- 9.区域非正常申请分析 -->
          <div>
            <div class="analyTitle">
              <div class="inside">
                <div class="inside-title">
                  <div></div>
                  区域非正常申请分析
                </div>
              </div>
            </div>
            <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
            <!-- 9-1.非正常商标申请人分布 -->
            <div
              id="notnormalsb"
              class="patent"
              style="margin-top: 22px; margin-bottom: 22px"
            >
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle2">非正常商标申请人分布</p>

              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="malice"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="代理量区间"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="非正常商标申请人数量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 9-2.非正常申请商标申请量Top10 -->
            <div id="notnormalsbtop" class="patent">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle2">非正常申请商标申请量Top10</p>

              <!-- 数据视图 -->
              <div>
                <div class="titleBox">
                  <el-button
                    @click="trseeMore50(18)"
                    :disabled="
                      maliceAppTmTop10.length === maliceAppTmTop50.length
                    "
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="maliceAppTmTop10"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="ap"
                    label="企业名称"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="商标申请量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- </div> -->
          </div>
          <div style="height: 30px; width: 100%; background: #f2f2f2"></div>
        </div>
        <!-- 商标数据视图结束 -->
        <!-- *****更多 弹框 -->
        <div v-if="trseeMore" class="popBoxMask"></div>
        <div v-if="trseeMore" class="popBox">
          <div class="boxHeader">
            {{ label50 }}排名
            <i class="el-icon-close" @click="closeMore"> </i>
          </div>
          <div class="boxContent">
            <div class="titleBox" style="width: 100%; margin-top: 0">
              <span
                style="
                  font-size: 18px;
                  color: #000;
                  text-align: left;
                  margin-left: 28px;
                  line-height: 50px;
                  font-weight: bold;
                "
                >{{ label50 }}Top50</span
              >
              <el-button @click="daochu(label50)">导出Excel</el-button>
            </div>
            <el-table :data="trtableData50" border style="width: 100%">
              <el-table-column
                :resizable="false"
                type="index"
                label="序号"
                width="60"
              >
              </el-table-column>
              <el-table-column
                :resizable="false"
                prop="AG"
                label="企业名称"
                v-if="label50 == '商标代理量'"
              ></el-table-column>
              <el-table-column
                :resizable="false"
                prop="ap"
                label="企业名称"
                v-else-if="label50 == '商标申请量'"
              ></el-table-column>
              <el-table-column
                :resizable="false"
                prop="name"
                label="企业名称"
                v-else
              ></el-table-column>
              <el-table-column :resizable="false" prop="num" :label="label50">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 企业数据视图开始 -->
      <div class="report-alasyis" v-if="usertype == '企业'">
        <div
          style="
            height: 11px;
            width: 100%;
            background: #f2f2f2;
            margin-top: 20px;
          "
        ></div>
        <!-- 3.国内专利分析 -->
        <div style="background-color: #fff">
          <div class="inside">
            <div class="inside-title">
              <div></div>
              国内专利分析
            </div>
          </div>
          <!-- <div class="analyTitle">国内专利分析</div> -->
          <!-- <div class="zl1" style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 3-1.国内专利趋势 -->
          <div id="gnzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">国内专利趋势</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="zltrendApList"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="专利申请量"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num2"
                    label="专利授权量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- <div v-show="!havedata1" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div> -->
          </div>
          <!-- 3-2.国际分类Top10 -->
          <div id="zllxgc" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">专利类型构成</p>
            <!-- <div class="sqSwitch">
              <button @click="applybtn(1)" :class="{ numbtn: numType1 == 1 }">
                申请量
              </button>
              <button @click="agreebtn(2)" :class="{ numbtn: numType1 == 2 }">
                授权量
              </button>
            </div> -->
            <!-- 数据视图 -->
            <div>
              <el-table
                :data="zlapTyCount"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="专利类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利申请量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-table
                :data="zlapTyAuthCount"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="专利类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利授权量"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- </div> -->
          <!-- 3-3.IPC技术分类top10 -->
          <div id="sqrgc" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">IPC技术分类top10</p>

            <!--面积图  -->

            <!-- <div  class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
            <!-- 数据视图 -->
            <div>
              <el-table
                :data="zlipcCount"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  type="index"
                  label="排序"
                  width="50"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="IPC技术分类"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="num"
                  label="专利申请量"
                  :resizable="false"
                >
                </el-table-column>
              </el-table>
            </div>

            <div>
              <div>
                <el-table
                  :data="zlipcAuthCount"
                  border
                  stripe
                  style="width: 90%; margin: 0 auto"
                >
                  <el-table-column
                    type="index"
                    label="排序"
                    width="50"
                    :resizable="false"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="IPC技术分类"
                    :resizable="false"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="专利授权量"
                    :resizable="false"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- 3-4.专利分析榜单 -->
          <div id="ipcjstop10" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">专利分析榜单</p>
            <div class="titleBox">
              <el-button
                @click="qyseeMore50(101)"
                :disabled="zlappTop10.length === zlappTop50.length"
                >更多</el-button
              >
              <!-- <el-button>导出</el-button> -->
            </div>
            <!-- 数据视图 -->
            <div>
              <el-table
                :data="zlappTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column
                  label="排序"
                  type="index"
                  width="50"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="企业名称"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="num"
                  label="专利申请量"
                  :resizable="false"
                >
                </el-table-column>
              </el-table>
            </div>
            <div>
              <div class="titleBox">
                <el-button
                  @click="qyseeMore50(102)"
                  :disabled="zlauthTop50.length === zlauthTop10.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="zlauthTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column
                  label="排序"
                  type="index"
                  width="50"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="企业名称"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="num"
                  label="专利授权量"
                  :resizable="false"
                >
                </el-table-column>
              </el-table>
            </div>
            <div>
              <div class="titleBox">
                <el-button
                  @click="qyseeMore50(103)"
                  :disabled="zlvalidTop10.length === zlvalidTop50.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="zlvalidTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column
                  label="排序"
                  type="index"
                  width="50"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="企业名称"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="num"
                  label="有效发明量(累计)"
                  :resizable="false"
                >
                </el-table-column>
              </el-table>
            </div>
            <div>
              <div class="titleBox">
                <el-button
                  @click="qyseeMore50(104)"
                  :disabled="zlnotValidTop10.length === zlnotValidTop50.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="zlnotValidTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column
                  label="排序"
                  type="index"
                  width="50"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="企业名称"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="num"
                  label="无效专利量"
                  :resizable="false"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 3-5.PCT专利趋势 -->
          <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
          <div class="inside">
            <div class="inside-title">
              <div></div>
              PCT公开专利分析
            </div>
          </div>
          <div id="yxfmwcfb" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">PCT专利趋势</p>

            <!-- 数据视图 -->
            <div>
              <el-table
                :data="zlpctTrendCount"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column :resizable="false" prop="name" label="时间">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="公开量">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 3-6.IPC分类Top10 -->
          <div id="gnzlfxbd" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">IPC分类Top10</p>

            <div>
              <el-table
                :data="zlpctIpcTop10"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  label="排序"
                  type="index"
                  width="50"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column prop="name" label="IPC分类" :resizable="false">
                </el-table-column>
                <el-table-column prop="num" label="申请量" :resizable="false">
                </el-table-column>
              </el-table>
            </div>
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle2">PCT公开量Top10</p>

            <div>
              <div class="titleBox">
                <el-button
                  @click="qyseeMore50(105)"
                  :disabled="zlpctTop10Count.length === zlpctTop50Count.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="zlpctTop10Count"
                border
                stripe
                style="width: 90%; margin: 2% auto 0"
              >
                <el-table-column
                  label="排序"
                  type="index"
                  width="50"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="企业名称"
                  :resizable="false"
                >
                </el-table-column>
                <el-table-column prop="num" label="公开量" :resizable="false">
                </el-table-column>
              </el-table>
            </div>
            <!--5.专利状态分析  -->
            <div style="background: #fff">
              <div class="inside">
                <div class="inside-title">
                  <div></div>
                  专利状态分析
                </div>
              </div>
              <!-- <div class="analyTitle">专利状态分析</div> -->
              <div id="zlztfx" class="patent">
                <div class="checkEchart left-text">
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
                <p class="biaoTitle2">专利状态分析</p>
                <div>
                  <!--饼状图  -->

                  <!--数据视图  -->
                  <div>
                    <el-table
                      :data="zlptLawCount"
                      border
                      stripe
                      style="width: 90%; margin: 2% auto 0"
                    >
                      <el-table-column
                        :resizable="false"
                        prop="name"
                        label="法律状态"
                      >
                      </el-table-column>
                      <el-table-column
                        :resizable="false"
                        prop="num"
                        label="专利量"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <!-- <div  class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
              </div>
            </div>
            <!-- 3.国内专利分析 -->
            <div style="background-color: #fff">
              <div class="inside">
                <div class="inside-title">
                  <div></div>
                  国内商标分析
                </div>
              </div>
              <!-- <div class="analyTitle">国内专利分析</div> -->
              <!-- <div class="zl1" style="margin-top: 22px; margin-bottom: 22px"> -->
              <!-- 3-1.国内专利趋势 -->
              <div id="gnzlqs" class="patent">
                <div class="checkEchart left-text">
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
                <p class="biaoTitle">国内商标趋势</p>
                <div>
                  <!-- 数据视图 -->
                  <div>
                    <el-table
                      :data="zltmTrendMap"
                      border
                      stripe
                      style="width: 90%; margin: 2% auto 0"
                    >
                      <el-table-column
                        :resizable="false"
                        prop="name"
                        label="时间"
                      >
                      </el-table-column>
                      <el-table-column
                        :resizable="false"
                        prop="num"
                        label="申请量"
                      >
                      </el-table-column>
                      <el-table-column
                        :resizable="false"
                        prop="num2"
                        label="注册量"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <!-- <div v-show="!havedata1" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div> -->
              </div>
              <!-- 3-2.国际分类Top10 -->
              <div id="zllxgc" class="patent">
                <div class="checkEchart left-text">
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
                <p class="biaoTitle">国际分类Top10</p>
                <!-- <div class="sqSwitch">
              <button @click="applybtn(1)" :class="{ numbtn: numType1 == 1 }">
                申请量
              </button>
              <button @click="agreebtn(2)" :class="{ numbtn: numType1 == 2 }">
                授权量
              </button>
            </div> -->
                <!-- 数据视图 -->
                <div>
                  <el-table
                    :data="zlicTop10Map"
                    border
                    stripe
                    style="width: 90%; margin: 2% auto 0"
                  >
                    <el-table-column
                      :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="IC"
                      label="国际分类"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="申请量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
                <div>
                  <el-table
                    :data="zlicRegTop10Map"
                    border
                    stripe
                    style="width: 90%; margin: 2% auto 0"
                  >
                    <el-table-column
                      :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="IC"
                      label="国际分类"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="注册量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
                <!-- <div  class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div> -->
              </div>
              <!-- </div> -->

              <!-- 3-4.国内商标分析榜单 -->
              <div id="ipcjstop10" class="patent">
                <div class="checkEchart left-text">
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
                <p class="biaoTitle2">国内商标分析榜单</p>
                <!-- <div class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div> -->
                <!-- 数据视图 -->
                <div>
                  <div class="titleBox">
                    <el-button
                      @click="qyseeMore50(106)"
                      :disabled="zltopApp50Map.length === zltopApp50Map.length"
                      >更多</el-button
                    >
                  </div>
                  <el-table
                    :data="zltopApp10Map"
                    border
                    stripe
                    style="width: 90%; margin: 0 auto"
                  >
                    <el-table-column
                      :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="name"
                      label="企业名称"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="申请量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
                <div>
                  <div class="titleBox">
                    <el-button
                      @click="qyseeMore50(107)"
                      :disabled="zlicRegTop10Map.length < 10"
                      >更多</el-button
                    >
                  </div>
                  <el-table
                    :data="zlicRegTop10Map"
                    border
                    stripe
                    style="width: 90%; margin: 0 auto"
                  >
                    <el-table-column
                      :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="IC"
                      label="企业名称"
                    >
                    </el-table-column>

                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="注册量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
                <div>
                  <div class="titleBox">
                    <el-button
                      @click="qyseeMore50(108)"
                      :disabled="
                        zltopValid50Map.length === zltopValid50Map.length
                      "
                      >更多</el-button
                    >
                  </div>
                  <el-table
                    :data="zltopValid10Map"
                    border
                    stripe
                    style="width: 90%; margin: 0 auto"
                  >
                    <el-table-column
                      :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="name"
                      label="企业名称"
                    >
                    </el-table-column>

                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="有效注册量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <!-- 3-5.马德里商标分析 -->
              <!-- <div style="height: 20px; width: 100%; background: #f2f2f2"></div> -->
              <div class="inside">
                <div class="inside-title">
                  <div></div>
                  马德里商标分析
                </div>
              </div>
              <div id="yxfmwcfb" class="patent">
                <div class="checkEchart left-text">
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
                <p class="biaoTitle2">马德里商标趋势</p>

                <!-- 数据视图 -->
                <div>
                  <el-table
                    :data="zlmadridTrend"
                    border
                    stripe
                    style="width: 90%; margin: 2% auto 0"
                  >
                    <el-table-column
                      :resizable="false"
                      prop="name"
                      label="时间"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="马德里注册量"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="num2"
                      label="马德里申请量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <!-- 3-6.马德里延伸国家TOP20 -->
              <div id="gnzlfxbd" class="patent">
                <div class="checkEchart left-text">
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
                <p class="biaoTitle2">马德里延伸国家TOP20</p>

                <!-- 数据视图 -->
                <div>
                  <el-table
                    :data="zlmadridExtendTop20"
                    border
                    stripe
                    style="width: 90%; margin: 2% auto 0"
                  >
                    <el-table-column
                      :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    ></el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="name"
                      label="马德里延伸国家"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="马德里注册量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <!-- 3-7.马德里注册量榜单 -->
              <div id="gnzlfxbd" class="patent">
                <div class="checkEchart left-text">
                  <i class="iconfont">&#xe6af;</i>
                  <p>数据视图</p>
                </div>
                <p class="biaoTitle2">马德里注册量Top10</p>

                <!-- 数据视图 -->
                <div>
                  <div class="titleBox">
                    <el-button
                      @click="qyseeMore50(112)"
                      :disabled="zlmadridTop10.length === zlmadridTop50.length"
                      >更多</el-button
                    >
                  </div>
                  <el-table
                    :data="zlmadridTop10"
                    border
                    stripe
                    style="width: 90%; margin: 2% auto 0"
                  >
                    <el-table-column
                      :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    ></el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="name"
                      label="企业名称"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="马德里注册量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
        style="height: 20px; width: 100%; background: #f2f2f2; margin-top: 20px"
      ></div> -->
        <!-- 4.商标状态分析 -->
        <div style="background: #fff">
          <div class="inside">
            <div class="inside-title">
              <div></div>
              商标状态分析
            </div>
          </div>
          <!-- <div class="analyTitle">PCT公开专利分析</div> -->
          <!-- <div -->

          <!-- 4-1.商标状态分析 -->
          <div id="pctzlqs" class="patent">
            <div class="checkEchart left-text">
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
            <p class="biaoTitle">商标状态分析</p>
            <div>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="zllawMap"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    prop="ls"
                    label="法律状态"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="商标量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>

          <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
          <!-- 7. 商标状态分析-->
          <div>
            <div class="analyTitle">
              <div class="inside">
                <div class="inside-title">
                  <div></div>
                  商标运营分析
                </div>
              </div>
            </div>
            <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->

            <div id="sbturn2" class="patent" style="margin-bottom: 20px">
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标转让趋势</p>
              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="zltmTransferMap"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column prop="name" label="时间" :resizable="false">
                  </el-table-column>
                  <el-table-column prop="num" label="转让量" :resizable="false">
                  </el-table-column>
                </el-table>
              </div>
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>

              <p class="biaoTitle">商标转让类别Top10</p>
              <div>
                <!-- 数据视图 -->
                <div>
                  <el-table
                    :data="zltmIcTrfTop"
                    border
                    stripe
                    style="width: 90%; margin: 2% auto 0"
                  >
                    <el-table-column
                      :resizable="false"
                      type="index"
                      label="排序"
                      width="60"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="name"
                      label="国际分类"
                    >
                    </el-table-column>
                    <el-table-column
                      :resizable="false"
                      prop="num"
                      label="转让量"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标许可趋势</p>
              <div>
                <!-- 数据视图 -->

                <el-table
                  :data="zltmLicenseMap"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="许可量">
                  </el-table-column>
                </el-table>
              </div>
              <!-- 7-4.商标许可类别Top10 -->

              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标许可类别Top10</p>

              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="zltmIcLicTop"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="国际分类"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="许可量">
                  </el-table-column>
                </el-table>
              </div>

              <!-- 7-5.商标质押趋势 -->

              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标质押趋势</p>

              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="zltmPledgeMap"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="质押量">
                  </el-table-column>
                </el-table>
              </div>

              <!-- 7-6.商标质押类别Top10 -->

              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle">商标质押类别Top10</p>

              <!-- 数据视图 -->
              <div>
                <el-table
                  :data="zltmIcPldTop"
                  border
                  stripe
                  style="width: 90%; margin: 2% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="国际分类"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="质押量">
                  </el-table-column>
                </el-table>
              </div>

              <!-- </div> -->
              <!-- 7-7. 商标运营分析榜单-->
              <!-- <div id="sbmanitop" class="patent"> -->
              <div class="checkEchart left-text">
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
              <p class="biaoTitle2">商标运营分析榜单</p>

              <!-- 数据视图 -->
              <div>
                <div class="titleBox">
                  <el-button
                    @click="qyseeMore50(109)"
                    :disabled="zltmTrfTop10.length === zltmTrfTop50.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="zltmTrfTop10"
                  border
                  stripe
                  class="el-tableclass"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="企业名称"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="商标转让量"
                  >
                  </el-table-column>
                </el-table>
              </div>

              <div>
                <div class="titleBox">
                  <el-button
                    @click="qyseeMore50(110)"
                    :disabled="zltmLicTop10.length === zltmLicTop50.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="zltmLicTop10"
                  border
                  stripe
                  class="el-tableclass"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="企业名称"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="商标许可量"
                  >
                  </el-table-column>
                </el-table>
              </div>

              <div>
                <div class="titleBox">
                  <el-button
                    @click="qyseeMore50(111)"
                    :disabled="zltmPldTop10.length === zltmPldTop50.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="zltmPldTop10"
                  border
                  stripe
                  class="el-tableclass"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="企业名称"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="商标质押量"
                  >
                  </el-table-column>
                </el-table>
              </div>

              <!-- </div> -->
            </div>

            <!-- </div> -->
            <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
          </div>
          <div style="height: 20px; width: 100%; background: #f2f2f2"></div>

          <div></div>
        </div>
        <!-- 企业数据视图结束 -->
        <!-- *****更多 弹框 -->
        <div v-if="qyseeMore" class="popBoxMask"></div>

        <div v-if="qyseeMore" class="popBox">
          <div class="boxHeader">
            {{ label50 }}排名
            <i class="el-icon-close" @click="closeMore"> </i>
          </div>
          <div class="boxContent">
            <div class="titleBox" style="width: 100%; margin-top: 0">
              <span
                style="
                  font-size: 18px;
                  color: #000;
                  text-align: left;
                  margin-left: 28px;
                  line-height: 50px;
                  font-weight: bold;
                "
                >{{ label50 }}Top50</span
              >
              <el-button @click="daochu(label50)">导出Excel</el-button>
            </div>
            <el-table :data="qytableData50" border style="width: 100%">
              <el-table-column
                :resizable="false"
                type="index"
                label="序号"
                width="60"
              >
              </el-table-column>
              <el-table-column :resizable="false" prop="name" label="企业名称">
              </el-table-column>
              <el-table-column :resizable="false" prop="num" :label="label50">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JsPDF from "jspdf";
import html2Canvas from "html2canvas";
import { mapState } from "vuex";
export default {
  data() {
    return {
      //导出数据
      timevalueS: "",
      region: "全部区域",
      exportPDFtitle: "",
      qyseeMore: false,
      trseeMore: false,
      zlseeMore: false,
      seeMore: false,
      dataSummary: {},
      usertype: "",
      userYear: "",
      reportTimes: "",
      reportYears: "",

      nowLastDay: "",
      newLastDay: "",
      isTableData: false,
      // ReportDataDetail:[],
      trendApList: [], //数据视图开始
      topList: [],
      apTyCountzl: [],
      timeRange: [],
      ipcCount: [],
      ipcAuthCount: [],
      appTop10: [],
      appTop50: [],
      zrTrend: [],
      zyTrend: [],
      xkTrend: [],
      label50: "",
      authTop10: [],
      authTop50: [],
      validTop10: [],
      validTop50: [],
      notValidTop10: [],
      notValidTop50: [],
      pctTrendCount: [],
      pctIpcTop10: [],
      pctTop10Count: [],
      pctTop50Count: [],
      ptLawCount: [],
      reportjggroupAuth: [],
      reportdzschoolAuth: [],
      reportsciencedwAuth: [],
      reportgkcompanyAuth: [],
      reportsingleAuth: [],
      tableData50: [],
      reportjggroup: [],
      reportdzschool: [],
      reportsciencedw: [],
      reportgkcompany: [],
      reportsingle: [],

      reportjggroupAuthYX: [],
      reportdzschoolAuthYX: [],
      reportsciencedwAuthYX: [],
      reportgkcompanyAuthYX: [],
      reportsingleAuthYX: [],

      reportjggroupYX: [],
      reportdzschoolYX: [],
      reportsciencedwYX: [],
      reportgkcompanyYX: [],
      reportsingleYX: [],

      ApplyXzl: [],
      ApplyFM: [],
      ApplySY: [],
      ApplyWG: [],
      AuthXzl: [],
      AuthFM: [],
      AuthSY: [],
      AuthWG: [],
      pctXzl: [],
      pctFM: [],
      pctSY: [],
      wxXzl: [],
      wxFM: [],
      wxSY: [],
      wxWG: [],
utilityValidInvzl:[],
designValidInvzl:[],
apValidInvzl:[],
      // 商标数据
      trData: {},
      tmTrendMap: [],
      tmapTyTrendForm: [],
      tmapTyTrendFormtime: [],
      tmapTyAuthTrendForm: [],
      icTop10Map: [],
      icRegTop10Map: [],
      tmtimeRange: [],
      jggroupsb: [],
      dzschoolsb: [],
      sciencedwsb: [],
      gkcompanysb: [],
      singlesb: [],
      jggroupAuthsb: [],
      dzschoolAuthsb: [],
      sciencedwAuthsb: [],
      gkcompanyAuthsb: [],
      singleAuthsb: [],
      topApp10Map: [],
      topApp50Map: [],
      topReg10Map: [],
      topReg50Map: [],
      topValid10Map: [],
      topValid50Map: [],
      madridTrend: [],
      madridExtendTop20: [],
      trtableData50: [],
      madridTop50: [],
      madridTop10: [],
      apTyAuthCountzl: [],
      lawMap: [],
      areaTmCompMap: [],
      areaRegTmCompMap: [],
      areaMadridTmCompMap: [],
      tmTransferMap: [],
      tmPledgeMap: [],
      tmLicenseMap: [],
      tmIcTrfTop: [],
      tmIcPldTop: [],
      tmIcLicTop: [],
      tmLicTop10: [],
      tmLicTop50: [],
      tmPldTop10: [],
      tmPldTop50: [],
      tmTrfTop10: [],
      tmTrfTop50: [],
      agentDist: [],
      agentTmTop10: [],
      agentTmTop50: [],
      malice: [],
      maliceAppTmTop10: [],
      maliceAppTmTop50: [],
      // 企业数据
      zltrendApList: [],
      zlapTyCount: [],
      zlapTyAuthCount: [],
      zlipcCount: [],
      zlipcAuthCount: [],
      zlappTop10: [],
      zlauthTop10: [],
      zlvalidTop10: [],
      zlnotValidTop10: [],
      zlappTop50: [],
      zlauthTop50: [],
      zlvalidTop50: [],
      zlnotValidTop50: [],
      zlpctTrendCount: [],
      zlpctIpcTop10: [],
      zlpctTop10Count: [],
      zlptLawCount: [],
      zltmTrendMap: [],
      zlicTop10Map: [],
      zlicRegTop10Map: [],
      zltopApp10Map: [],
      zltopValid10Map: [],
      qytableData50: [],
      zltopApp50Map: [],
      zltopValid50Map: [],
      zlpctTop50Count: [],
      // 马德里商标趋势
      zlmadridTrend: [],
      zlmadridExtendTop20: [],
      zlmadridTop10: [],
      zlmadridTop50: [],
      zllawMap: [],
      zltmTransferMap: [],
      zltmIcTrfTop: [],
      zltmLicenseMap: [],
      zltmIcLicTop: [],
      zltmPledgeMap: [],
      zltmIcPldTop: [],
      zltmTrfTop10: [],
      zltmTrfTop50: [],
      zltmLicTop10: [],
      zltmLicTop50: [],
      zltmPldTop10: [],
      zltmPldTop50: [],
      firmtotalS: 0,
      companyDatas: {},
      count: {},
    };
  },
  computed: {
    ...mapState(["ReportDataDetails"]),
  },
  created() {
    this.userYear = this.ReportDataDetails.id;
    this.exportPDFtitle = this.ReportDataDetails.name;
    if (this.userYear.length == 5) {
      this.reportTimes = this.userYear.substr(4, 5);
      // console.log('this.reportTimes',this.reportTimes)
      this.reportYears = this.userYear.substring(0, 4);
      //  console.log('this.reportYears',this.reportYears)
      if (this.reportTimes == 1) {
        this.reportTimes = 3;
      } else if (this.reportTimes == 2) {
        this.reportTimes = 6;
      } else if (this.reportTimes == 3) {
        this.reportTimes = 9;
      } else if (this.reportTimes == 4) {
        this.reportTimes = 12;
      }
      this.newLastDay = this.getLastDay(this.reportYears, this.reportTimes);

      this.nowLastDay =
        this.reportYears +
        "年" +
        this.reportTimes +
        "月" +
        this.newLastDay +
        "日";
    }
    if (this.userYear.length == 4) {
      // console.log('this.userYear',this.userYear)
      this.newLastDay = this.getLastDay(this.userYear, 12);
      this.nowLastDay =
        this.userYear + "年" + "12" + "月" + this.newLastDay + "日";
      // console.log('this.newLastDay ',this.newLastDay )
    }
    // this.getFirms();
  },
  mounted() {
    this.timevalueS = this.ReportDataDetails.id;

    // console.log('timevalueS',this.timevalueS)
    // console.log("ReportDataDetail", this.ReportDataDetails);
    // 报告类型
    this.usertype = this.ReportDataDetails.type;
    // console.log("this.usertype", this.usertype);
    this.pantsStats();
    this.trademarkData();
    this.companyData();
  },
  methods: {
    // 专利查看更多

    zlseeMore50(value) {
      this.zlseeMore = true;
      switch (value) {
        case 101:
          this.tableData50 = this.appTop50;
          this.label50 = "专利申请量";
          break;
        case 102:
          this.tableData50 = this.authTop50;
          this.label50 = "专利授权量";
          break;
        case 103:
          this.tableData50 = this.validTop50;
          this.label50 = "有效发明量(累计)";
          break;
        case 104:
          this.tableData50 = this.notValidTop50;
          this.label50 = "无效专利量";
          break;
        case 105:
          this.tableData50 = this.pctTop50Count;
          this.label50 = "PCT公开量";
          break;
      }
    },
    // 商标查看更多top50
    trseeMore50(value) {
      //  console.log('商标value',value)
      this.trseeMore = true;
      switch (value) {
        case 10:
          this.trtableData50 = this.topApp50Map;

          this.label50 = "申请量";
          break;

        case 11:
          this.trtableData50 = this.topReg50Map;
          this.label50 = "注册量";
          break;
        case 12:
          this.trtableData50 = this.topValid50Map;
          this.label50 = "有效注册量";
          break;
        case 13:
          this.trtableData50 = this.madridTop50;
          this.label50 = "马德里注册量";
          break;
        // case 105:
        //   this.trtableData50 = this.pctTop50Count;
        //   this.label50 = "PCT公开量";
        //   break;
        case 14:
          this.trtableData50 = this.tmTrfTop50;
          this.label50 = "商标转让量";
          break;
        case 15:
          this.trtableData50 = this.tmLicTop50;
          this.label50 = "商标许可量";
          break;
        case 16:
          this.trtableData50 = this.tmPldTop50;
          this.label50 = "商标质押量";
          break;
        case 17:
          this.trtableData50 = this.agentTmTop50;
          this.label50 = "商标代理量";
          break;
        case 18:
          this.trtableData50 = this.maliceAppTmTop50;
          this.label50 = "商标申请量";
          break;
      }
    },
    // 企业查看更多top50
    qyseeMore50(value) {
      // console.log('企业value',value)
      this.qyseeMore = true;
      if (value == 101) {
        this.qytableData50 = this.zlappTop50;
        this.label50 = "专利申请量";
      } else if (value == 102) {
        this.qytableData50 = this.zlauthTop50;
        this.label50 = "专利授权量";
      } else if (value == 103) {
        this.qytableData50 = this.zlvalidTop50;
        this.label50 = "有效发明量(累计)";
      } else if (value == 104) {
        this.qytableData50 = this.zlnotValidTop50;
        this.label50 = "无效发明量";
      } else if (value == 105) {
        this.qytableData50 = this.zlpctTop50Count;
        this.label50 = "PCT公开量";
      } else if (value == 106) {
        this.qytableData50 = this.zltopApp50Map;
        this.label50 = "申请量";
      } else if (value == 107) {
        this.qytableData50 = this.zltopReg50Map;
        this.label50 = "注册量";
      } else if (value == 108) {
        this.qytableData50 = this.zltopValid50Map;
        this.label50 = "有效注册量";
      } else if (value == 109) {
        this.qytableData50 = this.zltmTrfTop50;
        this.label50 = "商标转让量";
      } else if (value == 110) {
        this.qytableData50 = this.zltmLicTop50;
        this.label50 = "商标许可量";
      } else if (value == 111) {
        this.qytableData50 = this.zltmPldTop50;
        this.label50 = "商标质押量";
      } else if (value == 112) {
        this.qytableData50 = this.zlmadridTop50;
        this.label50 = "马德里注册量";
      }
    },
    // 导出更多
    daochu(value) {
      let aLink = document.createElement("a");
      aLink.href =
        this.$url +
        "applicant/alyTopExport?token=" +
        localStorage.getItem("token") +
        "&uid=" +
        localStorage.getItem("uid") +
        "&cnty=" +
        this.region +
        "&time=" +
        this.timevalueS +
        "&key=" +
        value;
      aLink.click();
    },
    //获得某月的最后一天
    getLastDay(year, month) {
      var new_year = year; //取当前的年份
      var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12) {
        new_month -= 12; //月份减
        new_year++; //年份增
      }
      var new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天
      return new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate(); //获取当月最后一天日期
    },

    // 封装转换年季度时间格式的方法
    switchTimeNew(value) {
      if (value.toString().split("").length === 4) {
        value = value + "年";
      }
      return value;
    },
    // 封装转换年季度时间格式的方法
    switchTime(value) {
      // console.log('value',value)
      // if(value.length === 5){
      //   return value
      // }
      // debugger;
      var e, y;
      if (value.toString().split("").length == 4) {
        value = value + "年";
        // console.log('value4',value)
        return value;
      } else if (value.toString().split("").length == 5) {
        e = value.slice(-1);
        // console.log('eeee',e)
        if (e == "1") {
          e = "第一季度";
        } else if (e == "2") {
          e = "第二季度";
        } else if (e == "3") {
          e = "第三季度";
        } else if (e == "4") {
          e = "第四季度";
        } else if (e == "年") {
          value = value.substring(0, 5);
          return value;
        }
        y = value.slice(0, 4);
        value = y + "年" + e;
        // console.log('555',value)
        return value;
      } else if (value.length == 6) {
        value = value.substring(0, 5);
        // console.log('value6',value)
        // return value;
      }
      // console.log('value',value)
      return value;
    },
    // 获取企业列表
    // getFirms() {
    //   this.$GET("/applicant/getApList").then((res) => {
    //     this.firmtotalS = this.firmsS.length;

    //   });
    // },

    btnClick() {
      this.$nextTick(() => {
        this.getPdf();
      });
    },
    // 专利数据统计
    pantsStats() {
      if (this.usertype == "专利") {
        this.trendApList =
          this.ReportDataDetails.json.domesticPtAly.trendApList;
        // console.log('this.trendApList',this.trendApList)
        this.trendApList.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });
        // console.log('this.trendApList',this.trendApList)
        this.topList = this.ReportDataDetails.json.topList;
        this.timeRange = this.ReportDataDetails.json.domesticPtAly.time;
        this.ipcCount = this.ReportDataDetails.json.domesticPtAly.ipcCount;
        this.ipcAuthCount =
          this.ReportDataDetails.json.domesticPtAly.ipcAuthCount;
        this.appTop10 = this.ReportDataDetails.json.ptTopList.appTop10;
        this.zrTrend = this.ReportDataDetails.json.ptTopList.zrTrend;
        this.zrTrend.forEach((ele) => {
          ele.time = this.switchTime(ele.time);
        });
        this.zyTrend = this.ReportDataDetails.json.ptTopList.zyTrend;
        this.zyTrend.forEach((ele) => {
          ele.time = this.switchTime(ele.time);
        });
        this.xkTrend = this.ReportDataDetails.json.ptTopList.xkTrend;
        this.xkTrend.forEach((ele) => {
          ele.time = this.switchTime(ele.time);
        });
        this.appTop50 = this.ReportDataDetails.json.ptTopList.appTop50;
        this.authTop10 = this.ReportDataDetails.json.ptTopList.authTop10;
        this.authTop50 = this.ReportDataDetails.json.ptTopList.authTop50;
        this.validTop10 = this.ReportDataDetails.json.ptTopList.validTop10;
        this.validTop50 = this.ReportDataDetails.json.ptTopList.validTop50;
        this.notValidTop10 =
          this.ReportDataDetails.json.ptTopList.notValidTop10;
        this.notValidTop50 =
          this.ReportDataDetails.json.ptTopList.notValidTop50;
        this.pctTrendCount = this.ReportDataDetails.json.ptPctAly.pctTrendCount;

        this.pctTrendCount.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });

        this.pctIpcTop10 = this.ReportDataDetails.json.ptPctAly.pctIpcTop10;
        this.pctTop10Count = this.ReportDataDetails.json.ptPctAly.pctTop10Count;
        this.pctTop50Count = this.ReportDataDetails.json.ptPctAly.pctTop50Count;

        this.ptLawCount = this.ReportDataDetails.json.ptLawAly.ptLawCount;
        this.ReportDataDetails.json.domesticPtAly.apTyTrendCount.forEach(
          (ele) => {
            this.reportjggroup.push(ele["机关团体"]);
            this.reportdzschool.push(ele["大专院校"]);
            this.reportsciencedw.push(ele["科研单位"]);
            this.reportgkcompany.push(ele["工矿企业"]);
            this.reportsingle.push(ele["个人"]);
          }
        );
        // console.log("this.reportjggroup", this.reportjggroup);
        this.ReportDataDetails.json.domesticPtAly.apTyAuthTrendCount.forEach(
          (ele) => {
            this.reportjggroupAuth.push(ele["机关团体"]);
            this.reportdzschoolAuth.push(ele["大专院校"]);
            this.reportsciencedwAuth.push(ele["科研单位"]);
            this.reportgkcompanyAuth.push(ele["工矿企业"]);
            this.reportsingleAuth.push(ele["个人"]);
          }
        );

        // this.ReportDataDetails.json.domesticPtAly.apValid.forEach(
        //   (ele) => {
        //     this.reportjggroupYX.push(ele["机关团体"]);
        //     this.reportdzschoolYX.push(ele["大专院校"]);
        //     this.reportsciencedwYX.push(ele["科研单位"]);
        //     this.reportgkcompanyYX.push(ele["工矿企业"]);
        //     this.reportsingleYX.push(ele["个人"]);
        //   }
        // );

        this.ReportDataDetails.json.domesticPtAly.apTyAuthValidInvCount.forEach(
          (ele) => {
            this.reportjggroupAuthYX.push(ele["机关团体"]);
            this.reportdzschoolAuthYX.push(ele["大专院校"]);
            this.reportsciencedwAuthYX.push(ele["科研单位"]);
            this.reportgkcompanyAuthYX.push(ele["工矿企业"]);
            this.reportsingleAuthYX.push(ele["个人"]);
          }
        );
        this.apValidInvzl = this.ReportDataDetails.json.domesticPtAly.apValidInv;
        this.utilityValidInvzl = this.ReportDataDetails.json.domesticPtAly.utilityValidInv;
        this.designValidInvzl = this.ReportDataDetails.json.domesticPtAly.designValidInv;
        this.apTyCountzl = this.ReportDataDetails.json.domesticPtAly.apTyCount;
        this.apTyAuthCountzl =
          this.ReportDataDetails.json.domesticPtAly.apTyAuthCount;
        // console.log('this.ReportDataDetails.json.areaCmpAly.areaApplyTrendCount',this.ReportDataDetails.json.areaCmpAly.areaApplyTrendCount)
        this.ReportDataDetails.json.areaCmpAly.areaApplyTrendCount.forEach(
          (ele) => {
            this.ApplyXzl.push(ele.cnty);
            this.ApplyFM.push(ele["发明"]);
            this.ApplySY.push(ele["实用新型"]);
            this.ApplyWG.push(ele["外观设计"]);
          }
        );
        this.ReportDataDetails.json.areaCmpAly.areaAuthTrendCount.forEach(
          (ele) => {
            this.AuthXzl.push(ele.cnty);
            this.AuthFM.push(ele["发明"]);
            this.AuthSY.push(ele["实用新型"]);
            this.AuthWG.push(ele["外观设计"]);
          }
        );
        this.ReportDataDetails.json.areaCmpAly.areaPctTrendCount.forEach(
          (ele) => {
            this.pctXzl.push(ele.cnty);
            this.pctFM.push(ele["PCT发明"]);
            this.pctSY.push(ele["PCT实用新型"]);
          }
        );
        this.ReportDataDetails.json.areaCmpAly.areaValidTrendCount.forEach(
          (ele) => {
            this.wxXzl.push(ele.cnty);
            this.wxFM.push(ele["发明"]);
            this.wxSY.push(ele["实用新型"]);
            this.wxWG.push(ele["外观设计"]);
          }
        );
      }
    },
    // 商标数据统计
    trademarkData() {
      if (this.usertype == "商标") {
        this.trData = this.ReportDataDetails.json;
        // console.log('商标简化数据',this.trData)
        this.dataSummary = this.ReportDataDetails.json.tmCount;
        // console.log(' this.dataSummary', this.dataSummary)
        this.tmTrendMap = this.trData.domesticTmAly.tmTrendMap;

        this.tmTrendMap.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });

        this.tmapTyTrendForm = this.trData.domesticTmAly.apTyTrendForm;
        this.tmapTyTrendForm.forEach((ele) => {
          this.jggroupsb.push(ele["机关团体"]);
          this.dzschoolsb.push(ele["大专院校"]);
          this.sciencedwsb.push(ele["科研单位"]);
          this.gkcompanysb.push(ele["工矿企业"]);
          this.singlesb.push(ele["个人"]);
        });
        this.tmtimeRange = this.trData.domesticTmAly.time;
        // console.log('this.SHIJIAN1 ',this.tmtimeRange )

        this.tmapTyAuthTrendForm = this.trData.domesticTmAly.apTyAuthTrendForm;
        this.tmapTyAuthTrendForm.forEach((ele) => {
          this.jggroupAuthsb.push(ele["机关团体"]);
          this.dzschoolAuthsb.push(ele["大专院校"]);
          this.sciencedwAuthsb.push(ele["科研单位"]);
          this.gkcompanyAuthsb.push(ele["工矿企业"]);
          this.singleAuthsb.push(ele["个人"]);
        });
        //  console.log('this,tmapTyTrendForm',this.tmapTyTrendForm)
        this.icTop10Map = this.trData.domesticTmAly.icTop10Map;
        this.icRegTop10Map = this.trData.domesticTmAly.icRegTop10Map;
        this.topApp10Map = this.trData.domesticTmAlyTop.topApp10Map;
        this.topApp50Map = this.trData.domesticTmAlyTop.topApp50Map;
        // console.log('---',this.topApp50Map)
        this.topReg10Map = this.trData.domesticTmAlyTop.topReg10Map;
        this.topReg50Map = this.trData.domesticTmAlyTop.topReg50Map;
        // console.log('3',this.topReg50Map)
        this.topValid10Map = this.trData.domesticTmAlyTop.topValid10Map;
        this.topValid50Map = this.trData.domesticTmAlyTop.topValid50Map;
        this.madridTrend = this.trData.tmPctAly.madridTrend;

        this.madridTrend.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });
        this.madridTop10 = this.trData.tmPctAly.madridTop10;
        this.madridExtendTop20 = this.trData.tmPctAly.madridExtendTop20;
        this.madridTop50 = this.trData.tmPctAly.madridTop50;
        // 商标状态
        this.lawMap = this.trData.tmLawAly.lawMap;
        this.areaTmCompMap = this.trData.tmLawAly.areaTmCompMap;
        this.areaRegTmCompMap = this.trData.tmLawAly.areaRegTmCompMap;
        this.areaMadridTmCompMap = this.trData.tmLawAly.areaMadridTmCompMap;
        this.tmTransferMap = this.trData.tmOprAly.tmTransferMap;

        this.tmTransferMap.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });

        this.tmIcTrfTop = this.trData.tmOprAly.tmIcTrfTop;
        this.tmPledgeMap = this.trData.tmOprAly.tmPledgeMap;

        this.tmPledgeMap.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });
        this.tmLicenseMap = this.trData.tmOprAly.tmLicenseMap;

        this.tmLicenseMap.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });

        this.tmIcPldTop = this.trData.tmOprAly.tmIcPldTop;
        this.tmIcLicTop = this.trData.tmOprAly.tmIcLicTop;
        this.tmLicTop10 = this.trData.tmOprAlyTop.tmLicTop10;
        this.tmLicTop50 = this.trData.tmOprAlyTop.tmLicTop50;
        this.tmPldTop10 = this.trData.tmOprAlyTop.tmPldTop10;
        this.tmPldTop50 = this.trData.tmOprAlyTop.tmPldTop50;
        // console.log('--------50',this.tmPldTop50)
        this.tmTrfTop10 = this.trData.tmOprAlyTop.tmTrfTop10;
        this.tmTrfTop50 = this.trData.tmOprAlyTop.tmTrfTop50;
        // console.log('--------50',this.tmTrfTop50)
        this.agentDist = this.trData.areaAgentAly.agentDist;
        this.agentTmTop10 = this.trData.areaAgentAly.agentTmTop10;
        this.agentTmTop50 = this.trData.areaAgentAly.agentTmTop50;
        // console.log('--------50',this.agentTmTop50)
        this.malice = this.trData.areaAgentAly.malice;
        this.maliceAppTmTop10 = this.trData.areaAgentAly.maliceAppTmTop10;
        this.maliceAppTmTop50 = this.trData.areaAgentAly.maliceAppTmTop50;
      }
    },
    // 企业数据统计
    companyData() {
      if (this.usertype == "企业") {
        this.companyDatas = this.ReportDataDetails.json;
        // console.log('企业简化数据',this.companyDatas)
        this.count = this.companyDatas.keyCompany.count;
        this.zltrendApList = this.companyDatas.domesticPtAly.trendApList;
        this.zltrendApList.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });
        this.zlapTyAuthCount = this.companyDatas.domesticPtAly.apTyAuthCount;
        this.zlapTyCount = this.companyDatas.domesticPtAly.apTyCount;
        this.zlipcCount = this.companyDatas.domesticPtAly.ipcCount;
        this.zlipcAuthCount = this.companyDatas.domesticPtAly.ipcAuthCount;
        this.zlappTop10 = this.companyDatas.domesticPtAly.appTop10;
        this.zlauthTop10 = this.companyDatas.domesticPtAly.authTop10;
        this.zlvalidTop10 = this.companyDatas.domesticPtAly.validTop10;
        this.zlnotValidTop10 = this.companyDatas.domesticPtAly.notValidTop10;
        this.zlappTop50 = this.companyDatas.domesticPtAly.appTop50;
        this.zlauthTop50 = this.companyDatas.domesticPtAly.authTop50;
        this.zlvalidTop50 = this.companyDatas.domesticPtAly.validTop50;
        this.zlnotValidTop50 = this.companyDatas.domesticPtAly.notValidTop50;

        this.zlpctTrendCount = this.companyDatas.ptPctAly.pctTrendCount;
        this.zlpctTrendCount.forEach((item) => {
          item.name = this.switchTime(item.name);
        });
        this.zlpctIpcTop10 = this.companyDatas.ptPctAly.pctIpcTop10;
        this.zlpctTop10Count = this.companyDatas.ptPctAly.pctTop10Count;

        this.zlpctTop50Count = this.companyDatas.ptPctAly.pctTop50Count;

        this.zlptLawCount = this.companyDatas.ptPctAly.ptLawCount;
        this.zltmTrendMap = this.companyDatas.domesticTmAly.tmTrendMap;
        this.zltmTrendMap.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });
        this.zlicTop10Map = this.companyDatas.domesticTmAly.icTop10Map;
        this.zlicRegTop10Map = this.companyDatas.domesticTmAly.icRegTop10Map;
        // console.log('企业名称',this.zlicRegTop10Map.length)
        this.zltopApp10Map = this.companyDatas.domesticTmAly.topApp10Map;
        this.zltopValid10Map = this.companyDatas.domesticTmAly.topValid10Map;

        this.zltopApp50Map = this.companyDatas.domesticTmAly.topApp50Map;
        this.zltopValid50Map = this.companyDatas.domesticTmAly.topValid50Map;
        this.zlmadridTrend = this.companyDatas.tmMadridAndLawAly.madridTrend;
        this.zlmadridTrend.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });
        this.zlmadridExtendTop20 =
          this.companyDatas.tmMadridAndLawAly.madridExtendTop20;
        this.zlmadridTop10 = this.companyDatas.tmMadridAndLawAly.madridTop10;
        this.zlmadridTop50 = this.companyDatas.tmMadridAndLawAly.madridTop50;
        this.zllawMap = this.companyDatas.tmMadridAndLawAly.lawMap;
        this.zltmTransferMap = this.companyDatas.tmOprAly.tmTransferMap;
        this.zltmTransferMap.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });
        this.zltmIcTrfTop = this.companyDatas.tmOprAly.tmIcTrfTop;
        this.zltmLicenseMap = this.companyDatas.tmOprAly.tmLicenseMap;
        this.zltmIcLicTop = this.companyDatas.tmOprAly.tmIcLicTop;
        this.zltmPledgeMap = this.companyDatas.tmOprAly.tmPledgeMap;
        this.zltmPledgeMap.forEach((ele) => {
          ele.name = this.switchTime(ele.name);
        });
        this.zltmIcPldTop = this.companyDatas.tmOprAly.tmIcPldTop;
        this.zltmTrfTop10 = this.companyDatas.tmOprAly.tmTrfTop10;
        this.zltmTrfTop50 = this.companyDatas.tmOprAly.tmTrfTop50;
        this.zltmLicTop10 = this.companyDatas.tmOprAly.tmLicTop10;
        this.zltmLicTop50 = this.companyDatas.tmOprAly.tmLicTop50;
        this.zltmPldTop10 = this.companyDatas.tmOprAly.tmPldTop10;
        this.zltmPldTop50 = this.companyDatas.tmOprAly.tmPldTop50;
      }
    },
    // 关闭更多弹框
    closeMore() {
      this.zlseeMore = false;
      this.trseeMore = false;
      this.qyseeMore = false;
    },
  },
};
</script>
<style >
.new-location {
  float: right;
  margin: 25px;
}
.report-content {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: absolute;
  bottom: 0;
}

.report-header {
  background-image: url("../assets/imgs/report-bg.png");
  width: 100%;
  height: 200px;
}
.report-header .report-title {
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  padding-top: 70px;
  letter-spacing: 1.63px;
}
.report-header .report-data {
  font-size: 14px;
  margin-top: 10px;
}
.report-alasyis {
  margin-top: 14px;
}
</style>